export default __webpack_public_path__ + "static/media/pushplay-icon.399e6f19.png";